module.exports = __webpack_public_path__ + "0349ca502d098c0b17a75a83cc6e029f.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/PromotionBlock/images/promotion_image4.png
// module id = 1486
// module chunks = 3